import {Component, Inject, OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig} from '@angular/material/legacy-snack-bar';
import {BehaviorSubject, Subject} from 'rxjs';
import {PASSWORD_STRENGTH_INFO} from '@app/core/utils/password-utils';
import {takeUntil} from 'rxjs/operators';
import {INVALID_PASSWORD_STATUS_CODE, User} from '@app/core/model/user';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';

@Component({
    selector: 'ngc-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent implements OnInit {

    formGroup: UntypedFormGroup;
    currentPassword: UntypedFormControl;
    password: UntypedFormControl;
    confirmPassword: UntypedFormControl;
    isSaving: boolean;
    isVertical = false;
    hidePassword$ = new BehaviorSubject<boolean>(true);

    readonly PASSWORD_STRENGTH_INFO = PASSWORD_STRENGTH_INFO;
    readonly PASSWORD_CHANGED_MESSAGE = 'Password has been changed.';
    readonly CHANGE_PASSWORD_FAILED_MESSAGE = 'The current password you entered is incorrect.';

    private unsubscribe$ = new Subject<void>();

    constructor(private dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
                private snackBar: MatSnackBar,
                private formBuilder: UntypedFormBuilder,
                private authenticatedUserService: AuthenticatedUserService,
                @Inject(MAT_DIALOG_DATA) public injectedData: {
                    user: User;
                }) {
        this.currentPassword = new UntypedFormControl('');
        this.password = new UntypedFormControl('');
        this.confirmPassword = new UntypedFormControl('');
        this.formGroup = this.formBuilder.group({
            currentPassword: this.currentPassword,
            password: this.password,
            confirmPassword: this.confirmPassword
        });
    }

    ngOnInit(): void {
    }

    onSave() {
        this.isSaving = true;
        this.updateCurrentUserPassword();
        // this.authenticatedUserService.refreshAuthenticatedUser();
        // this.dialogRef.close(value);
    }

    onCancel() {
        this.dialogRef.close();
    }

    isSaveDisabled(): boolean {
        return ((this.formGroup?.controls?.password.invalid || this.formGroup?.controls?.confirmPassword.invalid)
                && (this.formGroup?.controls?.password.value || this.formGroup?.controls?.confirmPassword.value))
            || this.isSaving
            || this.formGroup?.pristine
            || (!this.formGroup?.controls?.password.value)
            || (!this.formGroup?.controls?.password.value);
    }

    private updateCurrentUserPassword(): void {
        if ((this.formGroup.controls.password.valid && this.formGroup.controls.confirmPassword.valid)
            && (this.formGroup.controls.password.value && this.formGroup.controls.confirmPassword.value)) {
            this.toggleIsChangingPassword(true);

            this.authenticatedUserService.updateCurrentUserPassword(this.currentPassword.value, this.password.value)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => {
                    this.authenticatedUserService.refreshAuthenticatedUser();
                    this.toggleIsChangingPassword(false);
                    this.snackBar.open(this.PASSWORD_CHANGED_MESSAGE, '', <MatSnackBarConfig>{duration: 2000});
                    this.formGroup.controls.password.reset();
                    this.formGroup.controls.confirmPassword.reset();
                    this.formGroup.markAsUntouched();
                    this.dialogRef.close(true);
                },
                err => {
                    this.toggleIsChangingPassword(false);
                    const errorMessage = (err.status === INVALID_PASSWORD_STATUS_CODE
                        ? err.message
                        : this.CHANGE_PASSWORD_FAILED_MESSAGE
                    );
                    this.snackBar.open(errorMessage, 'ERROR', <MatSnackBarConfig>{duration: 2000});
                    this.formGroup.markAsPristine();
                    this.formGroup.markAsUntouched();
                    this.isSaving = false;
                });
        }
    }

    private toggleIsChangingPassword(isChangingPassword: boolean): void {
        this.isSaving = isChangingPassword;
    }
}
